import React, { useState } from 'react';
import { useAppStore } from '../../../../store/useAppStore';
import AssetPicker from '../../../Assets/AssetPicker';

export const ImageForm = ({ component, onUpdate }) => {
  const [showUploader, setShowUploader] = useState(false);
  const { appName } = useAppStore();

  const handleChange = (field, value) => {
    onUpdate(component.id, {
      specificAttrs: { ...component.specificAttrs, [field]: value }
    });
  };

  const { specificAttrs } = component;

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      {/* Asset Picker for selecting from library or uploading */}
      {appName && (
        <AssetPicker
          appId={appName}
          value={specificAttrs.src || ''}
          onChange={(url) => handleChange('src', url)}
          label="Image Asset"
          fileType="image"
          placeholder="Select an image from library..."
          showPreview={true}
        />
      )}
      
      {/* Manual URL Input (fallback) */}
      <div>
        <label style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563', display: 'block', marginBottom: '4px' }}>
          Or Enter Image URL Manually
        </label>
        <input
          type="text"
          value={specificAttrs.src || ''}
          onChange={(e) => handleChange('src', e.target.value)}
          placeholder="https://example.com/image.jpg"
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Alt Text
        </label>
        <input
          type="text"
          value={specificAttrs.alt || ''}
          onChange={(e) => handleChange('alt', e.target.value)}
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Object Fit
          </label>
          <select
            value={specificAttrs.objectFit || 'cover'}
            onChange={(e) => handleChange('objectFit', e.target.value)}
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px'
            }}
          >
            <option value="cover">Cover</option>
            <option value="contain">Contain</option>
            <option value="fill">Fill</option>
            <option value="none">None</option>
          </select>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Border Radius (px)
          </label>
          <input
            type="number"
            value={specificAttrs.borderRadius || 0}
            onChange={(e) => handleChange('borderRadius', e.target.value)}
            min="0"
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px'
            }}
          />
        </div>
      </div>
      <div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.lazyLoad}
            onChange={(e) => handleChange('lazyLoad', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>
            Enable Lazy Loading
          </span>
        </label>
      </div>
    </div>
  );
};
